export const FEATURED_PHOTOGRAPHER_HANDLE = 'cars.a.n.d.moto.0'

function normalizeHandle(value) {
  return String(value || '').trim().toLowerCase().replace(/^@/, '')
}

export function isFeaturedPhotographerProfile(profileOrHandle) {
  if (!profileOrHandle) return false

  if (typeof profileOrHandle === 'string') {
    return normalizeHandle(profileOrHandle) === FEATURED_PHOTOGRAPHER_HANDLE
  }

  return normalizeHandle(profileOrHandle.handle) === FEATURED_PHOTOGRAPHER_HANDLE
}
